export const mapHostToPath: Record<string, string> = {
  'vkdating-app.ru': 'vkdating-app',
  'stage.vkdating-app.ru': 'vkdating-app',
  default: 'dating',
};

export function getManifestIcon(name: string, host: string) {
  const prefix = mapHostToPath[host] || mapHostToPath.default;
  return `${prefix}-${name}`;
}
